import React from 'react';
import getContent from '../../../lib/dictionaryFetcher';
import PropTypes from 'prop-types';
import { get } from 'lodash';

const getImageLink = (bundleId, selectedNavItem, bundles) => {
  let type = 'normal';
  if (bundleId === selectedNavItem) {
    type = 'blue';
  }
  return get(
    bundles,
    `${bundleId}.ppObjectLink.${type}`,
    'https://www.paypalobjects.com/ppcp/images/buttons.svg'
  );
};

const ProductNav = props => {
  const {
    bundleId,
    selectedNavItem,
    onClickNavItem,
    sticky,
    isShowingSupportSection,
    bundles
  } = props;
  let imageLink = getImageLink(bundleId, selectedNavItem, bundles),
    financialSupportCheck = bundleId === 'raiseFinancialSupport' && !sticky;
  return (
    <div
      onClick={() => {
        onClickNavItem(bundleId);
      }}
      className={`covid-nav-item covid-nav-item-${bundleId} ${selectedNavItem ===
        bundleId && 'covid-nav-item-selected'} ${!sticky &&
        'covid-nav-item-arrow'}`}
      style={{
        marginRight: isShowingSupportSection ? '10px' : '0px'
      }}
    >
      <div
        className={`${financialSupportCheck &&
          'financial-support'} covid-nav-item-content covid-nav-item-content-${bundleId}`}
      >
        <img
          className={`covid-nav-item-content-img covid-nav-item-content-img-${bundleId}`}
          src={imageLink}
          alt={`${bundleId}-icon`}
        />
        <p
          className={`covid-nav-item-content-title covid-nav-item-content-title-${bundleId}`}
          style={{ color: selectedNavItem === bundleId && '#0070BA' }}
        >
          <span>{getContent('covidbundles', `${bundleId}.title`, '')}</span>
        </p>
        {bundleId === 'raiseFinancialSupport' && (
          <span className="ppvx_badge ppvx_badge--type_success ppvx_badge--status raiseFinancialSupport">
            {getContent('covidbundles', 'raiseFinancialSupport.newTitle')}
          </span>
        )}
      </div>
    </div>
  );
};

ProductNav.propTypes = {
  bundleId: PropTypes.string,
  selectedNavItem: PropTypes.string,
  onClickNavItem: PropTypes.func,
  sticky: PropTypes.bool,
  isShowingSupportSection: PropTypes.bool,
  bundles: PropTypes.object
};

export default ProductNav;
